import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {TranslateService} from '@ngx-translate/core';
import {ECaseSnackBarService, ECaseUtils, ExplorerService} from 'synto-common';
import {DocumentItem} from '../document-list.models';

export interface DocumentReplaceDialogData {
  row: DocumentItem;
}

@Component({
  selector: 'app-document-replace-dialog',
  templateUrl: './document-replace-dialog.component.html',
  styleUrls: ['./document-replace-dialog.component.scss']
})
export class DocumentReplaceDialogComponent {

  uploadedFile: File | undefined;
  submitting = false;

  constructor(
    public dialogRef: MatDialogRef<DocumentReplaceDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DocumentReplaceDialogData,
    private translate: TranslateService,
    private explorerService: ExplorerService,
    private eCaseSnackBarService: ECaseSnackBarService
  ) {
  }

  uploadFile($event: Event): void {
    const input = $event.target as HTMLInputElement;
    this.uploadedFile = input.files?.[0];
  }

  removeFile(): void {
    this.uploadedFile = undefined;
  }

  onConfirm(): void {
    if (!this.uploadedFile || !this.data?.row || this.submitting) {
      return;
    }
    const edmRepositoryDocumentId = this.data.row?.edmRepositoryDocumentId;
    if (!edmRepositoryDocumentId) {
      this.eCaseSnackBarService.show(
        'failure',
        ECaseUtils.getTranslatedValueFromKey(this.translate, 'ecase.explorer.documentList.replace.documentIdMissing')
      );
      return;
    }
    this.submitting = true;
    const formData = new FormData();
    formData.append('file', this.uploadedFile);
    this.explorerService.replaceDocument(edmRepositoryDocumentId, formData).subscribe({
      next: () => {
        this.eCaseSnackBarService.show(
          'success',
          ECaseUtils.getTranslatedValueFromKey(this.translate, 'ecase.explorer.documentList.replace.success')
        );
        this.dialogRef.close(true);
      },
      error: (error: any) => {
        this.submitting = false;
        const errorMessage = error?.errorMessage ||
          error?.error?.errorMessage ||
          error?.error?.message ||
          error?.message ||
          'ecase.explorer.documentList.replace.error';
        this.eCaseSnackBarService.show(
          'failure',
          ECaseUtils.getTranslatedValueFromKey(this.translate, errorMessage)
        );
      }
    });
  }

  onClose(): void {
    this.dialogRef.close(false);
  }

}
